import axios from "@axios";

export default {
    namespaced: true,
    state: {
        downloadFT: [],
        embarque_items: [],
        mercados: [],
        bancos: [],
        cobranza: [],
    },
    getters: {
        getEmbarqueItems(state) {
            return state.embarque_items;
        },
        getMercados(state) {
            return state.mercados;
        },
        getBancosPanacea(state) {
            return state.bancos;
        },
        getCobranzaMercado(state) {
            return state.cobranza;
        },
    },
    mutations: {
        setDownloadFT(state, downloadFT) {
            state.downloadFT = downloadFT;
        },
        setEmbarqueItems(state, embarque_items) {
            state.embarque_items = embarque_items;
        },
        setMercados(state, mercados) {
            state.mercados = mercados;
        },
        setBancos(state, bancos) {
            state.bancos = bancos;
        },
        setCobranzaMercado(state, cobranza) {
            state.cobranza = cobranza;
        },
    },
    actions: {
        fetchProformas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/produccion/panacea/proformas", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchProformaById({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/produccion/panacea/proforma", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchItemPanacea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/produccion/panacea/itemPanacea", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchDownloadFTItemCamaron({ commit }, data) {
            return new Promise((resolve, reject) => {
                var link = "/api/auth/produccion/panacea/downloadFTItemCamaron";
                axios({
                    method: "post",
                    url: link,
                    responseType: "blob",
                    data: data,
                })
                    .then((response) => {
                        commit("setDownloadFT", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        fetchEmbarqueItems({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/produccion/panacea/embarqueItems", {
                        params: data,
                    })
                    .then((response) => {
                        commit("setEmbarqueItems", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchFacturasEmbarque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/panaceaEmbarque/facturasEmbarque", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchMercados({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/panaceaEmbarque/mercados")
                    .then((response) => {
                        commit("setMercados", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchBancosPanacea({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/panaceaEmbarque/bancosPanacea")
                    .then((response) => {
                        commit("setBancos", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fecthModificarEmbarqueFactura({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/panaceaEmbarque/modificarEmbarque", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fecthModificarEmbarqueFacturaMasivo({ commit }, data){
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/panaceaEmbarque/modificarEmbarqueMasivo", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });

        },
        fetchEmbarquePendientes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/panaceaEmbarque/embarquePendiente", { params: data})
                    .then(response => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchResumenAsia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/panaceaEmbarque/resumenAsia", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchPaisesMercado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/panaceaEmbarque/paisesMercado", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchFormasPago({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/panaceaEmbarque/formasPago")
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchAnioNuevo({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/panaceaEmbarque/getUltimaAnio")
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchCreateAnioNuevo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/panaceaEmbarque/nuevoAnio", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        //aqui
        //Diego
        fetchCobranzaMercado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/panaceaEmbarque/cobranzaMercado", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
    async findItemCamaronProforma({ commit }, params) {
      return (await axios.get('/api/auth/produccion/panacea/proforma/item-camaron', { params })).data
    },
    async fetchItemsCamaronProforma({ commit }, params) {
      return (await axios.get('/api/auth/produccion/panacea/proforma/items-camaron', { params })).data
    },
    async findItemBodegaProforma({ commit }, params) {
      return (await axios.get('/api/auth/produccion/panacea/proforma/item-bodega', { params })).data
    },
    async fetchItemsBodegaProforma({ commit }, params) {
      return (await axios.get('/api/auth/produccion/panacea/proforma/items-bodega', { params })).data
    },
  },
}
